module.exports = __webpack_public_path__ + "static/goals-de13cff8e946e4a97d13d0f9902461af.mp4";